@if (loading()) {
  <app-loading></app-loading>
} @else {
  <app-header 
    [icon]="'arrow_back_ios'"
    (iconClickedEvent)="back()">
  </app-header>
  <div class="container">
    <img src="imgs/icon.png" class="logo-icon">
    <div class="sub-title">
      @if(!appointment()){
        {{'add-appointment.title' | translate }}
      }@else{
        {{'add-appointment.edit' | translate }}
      }
    </div>
    <div class="form-container">
      <form [formGroup]="appoitmentForm" class="form">
      <p class="label">{{ 'labels.patient' | translate }}</p>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="patientControl" (openedChange)="onPatientSelectOpened($event)">
          <mat-option disabled class="patient-search-option">
            <input
              #patientSearchInput
              matInput
              type="text"
              [value]="patientSearchTerm()"
              [placeholder]="'placeholders.search_patient' | translate"
              autocomplete="off"
              class="patient-search-input"
              (mousedown)="$event.stopPropagation()"
              (input)="onPatientSearch($event)"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()">
          </mat-option>
          @for (item of filteredPatients(); track item.id) {
            <mat-option [value]="item.id">{{item.first_name + ' ' + item.last_name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (
        patientControl.invalid 
        && patientControl.errors
        && (patientControl.touched || patientControl.dirty)
      ) {
        @if (patientControl.errors['required']) {
          <div class="error">
            {{ 'errors.field_required' | translate }}
          </div>
        } @else {
          <div class="error">
            {{ 'errors.invalid_field' | translate }}
          </div>
        }
      }
      
      <app-input 
        [label]="'labels.title' | translate"
        [formControl]="titleControl"
        type="text"
      ></app-input>

      <app-text-area
        [label]="'labels.description'| translate"
        [control]="descriptionControl"
      ></app-text-area>

      @if (
        descriptionControl.invalid 
        && descriptionControl.errors
        && (descriptionControl.touched || descriptionControl.dirty)
      ) {
        @if (descriptionControl.errors['required']) {
          <div class="error">
            {{ 'errors.field_required' | translate }}
          </div>
        } @else {
          <div class="error">
            {{ 'errors.invalid_field' | translate }}
          </div>
        }
      }

      <app-input 
        [label]="'labels.date' | translate"
        [formControl]="dateControl"
        type="date"
      ></app-input>

      <app-input 
        [label]="'labels.time' | translate"
        [formControl]="timeControl"
        type="time"
      ></app-input>

      <p class="label">{{ 'labels.duration' | translate }}</p>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="durationControl" >
          @for (item of DURATIONS; track item.code) {
            <mat-option [value]="item.code">{{item.label | translate}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (
        durationControl.invalid 
        && durationControl.errors
        && (durationControl.touched || durationControl.dirty)
      ) {
        @if (durationControl.errors['required']) {
          <div class="error">
            {{ 'errors.field_required' | translate }}
          </div>
        } @else {
          <div class="error">
            {{ 'errors.invalid_field' | translate }}
          </div>
        }
      }

      <app-input 
        [label]="'labels.price' | translate"
        [formControl]="valueControl"
        type="number"
      ></app-input>

      <p class="label">{{ 'labels.currency' | translate }}</p>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="currencyControl" >
          @for (item of CURRENCIES; track item.code) {
            <mat-option [value]="item.code">{{item.code + ' - ' + item.symbol}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (
        currencyControl.invalid 
        && currencyControl.errors
        && (currencyControl.touched || currencyControl.dirty)
      ) {
        @if (currencyControl.errors['required']) {
          <div class="error">
            {{ 'errors.field_required' | translate }}
          </div>
        } @else {
          <div class="error">
            {{ 'errors.invalid_field' | translate }}
          </div>
        }
      }

      <div class="checks-container">
        <mat-checkbox 
          class="custom-checkbox" 
          [formControl]="confirmationControl">
            {{'labels.needs_confirmation' | translate}}
        </mat-checkbox>
        <p>{{'labels.user_confirmation' | translate}}</p>
        
        <mat-checkbox 
          class="custom-checkbox" 
          [formControl]="calendarControl">
            {{'labels.sync_google_calendar' | translate}}
        </mat-checkbox>
        <p>{{'labels.calendar_meet' | translate}}</p>

        @if(!appointment()){
          <mat-checkbox 
            class="custom-checkbox" 
            [formControl]="recurringWeeklyControl">
              {{'labels.recurring_weekly_appointment' | translate}}
          </mat-checkbox>
          <p>{{'labels.recurring_weekly_description' | translate}}</p>
        }
      </div>

      @if(!appointment() && recurringWeeklyControl.value){
        <app-input 
          [label]="'labels.recurrence_occurrences' | translate"
          [formControl]="recurrenceOccurrencesControl"
          [placeholder]="'placeholders.occurrences_min_2' | translate"
          type="number"
        ></app-input>
      }

      </form>

      <div class="actions-container">
        <app-button 
          [buttonLabel]="'buttons.cancel' | translate"
          [buttonType]="BUTTON_TYPES.OUTLINED" 
          [buttonDisabled]="false"
          (click)="back()">
        </app-button>
        <app-button
          [buttonLabel]="'buttons.save' | translate"
          [buttonType]="BUTTON_TYPES.REGULAR" 
          [buttonDisabled]="isFormInvalid()"
          (click)="createAppoitment()">
        </app-button>
      </div>
      
    </div>
  </div>
}
